// import React, { useEffect, useState } from 'react'
// import Breadcrumbs from '../../common/breadcrumb/Breadcrumbs'
// import { getDataPacage, getDataPacageSales, getDataReports } from '../../api/login/Login'
// import SameCompFilter from './SameCompFilter'
// import FastagListReports from './FastagListReport'
// import { useParams } from 'react-router-dom'

// function FastagMainComp({title_1,title_2,title}) {
//   const breadCrumbsTitle = {
//     id: "1",
//     title_1: title_1,
//     title_2:  title_2,
//   }
//   const [count, setCount] = useState(10)
//   const [page, setPage] = useState(0)
//   const [aepsData, setAepsData] = useState()
//   const [loading, setLoading] = useState(false)
//   const [userData, setUserData] = useState(false)
//   const token = window.localStorage.getItem('userToken')
//   const param = useParams()
//   const getCurrentDate = () => {
//     const date = new Date();
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
// };
//   const [initialValues, setIntialValues] = useState({
//     name: "",
//     start_date: getCurrentDate(),
//     end_date: getCurrentDate(),
//     biller_id: "",
//     txn_id: "",
//     customer_mobile: "",
//     category_id: param.id
//   })
//   const [operatorId, setOpratorID] = useState("")


//   const handleChangeOp = (e) => {
//     setOpratorID(e.target.value)
//   }
//   const submitForm = async (values) => {
//     const txnId = values.txn_id ? values.txn_id.trim() : '';
//     setLoading(true);
//     setIntialValues({
//       ...values, count, biller_id: operatorId, txn_id: txnId
//     })
//     setPage(0)
//     try {

//       const res = await getDataReports({ ...values, page: 0, count, txn_id: txnId, biller_id: operatorId, category_id: param.id });
//       setAepsData(res);
//     } catch (error) {
//       console.error("Error during AEPS transaction filter:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getDmtTxnData = async (num) => {
//     setLoading(true)
//     try {
//       const res = await getDataReports({ ...initialValues, page: num, count, category_id: param.id });

//       setAepsData(res);
//       setLoading(false)
//     } catch (error) {

//     }
//   }




//   const onChangeVal = (e) => {
//     setPage(e - 1)
//     setTimeout(() => {
//       getDmtTxnData(e - 1)
//     }, 1000);
//   };

//   useEffect(() => {
//     setTimeout(() => {
//       getDmtTxnData(0)
//     }, 1000);
//   }, [])
//   return (
//     <>
//       <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />
//       <SameCompFilter setOpratorID={setOpratorID} title={title} initialValues={initialValues} setIntialValues={setIntialValues} submitForm={submitForm} aepsData={aepsData} handleChangeOp={handleChangeOp} operatorId={operatorId} getDmtTxnData={getDmtTxnData} page={page}/>
//       <FastagListReports title={title} onChangeVal={onChangeVal} aepsData={aepsData} getDmtTxnData={getDmtTxnData}/>
//     </>
//   )
// }

// export default FastagMainComp


// import React, { useEffect, useState } from 'react'
// import Breadcrumbs from '../../common/breadcrumb/Breadcrumbs'
// // import { getDataPacage, getDataPacageSales, getDataReports  ,getDataReportsAllexcel} from '../../api/login/Login'
// import SameCompFilter from './SameCompFilter'
// import ElectricListReport from './ElectricListReport'
// import { useParams } from 'react-router-dom'
// import Loadar from '../../common/loader/Loader'

import React, { useEffect, useState } from 'react'
import SameCompFilter from './SameCompFilter'
import * as XLSX from 'xlsx'; 
import Breadcrumbs from '../../common/breadcrumb/Breadcrumbs'
import { message } from 'antd';
import { getDataReports ,getDataReportsAllexcel ,paymentEnquirybbps} from '../../api/login/Login';
import FastagListReports from './FastagListReport'
import { useParams } from 'react-router-dom';
import Loadar from '../../common/loader/Loader';

function FastagMainComp({ title_1, title_2, title }) {
  const breadCrumbsTitle = {
    id: "1",
    title_1: title_1,
    title_2: title_2,
  };

  const getCurrentDate = () => {
    const today = new Date();
    return today.toISOString().substr(0, 10);
  };

  const [currentDate, setCurrentDate] = useState(getCurrentDate());
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(0);
  const [aepsData, setAepsData] = useState({ data: [] });
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [userData, setUserData] = useState(false);
  const token = window.localStorage.getItem('userToken');
  const param = useParams();
  const [initialValues, setInitialValues] = useState({
    name: "",
    start_date: currentDate,
    end_date: currentDate,
    biller_id: "",
    txn_id: "",
    customer_mobile: "",
    category_id: param.id,
    user_id: "",
    member_code: "",
    member_name: "",
    operator_id: "",
  });

  const submitForm = async (values) => {
    console.log(values);
    
    const txnId = values.txn_id ? values.txn_id.trim() : '';
    setLoading(true);
    setInitialValues({
      ...values,
      count,
      txn_id: txnId,
      start_date: values.start_date ? values.start_date : '',
      end_date: values.end_date ? values.end_date : '',
    });
    setPage(0);
    try {
      const res = await getDataReports({ 
        ...values, 
        page: 0, 
        count, 
        txn_id: txnId, 
        category_id: param.id,
      });
      if (res && res.data) {
        setAepsData(res);
      } else {
        setAepsData({ data: [] });
        message.info('No data available');
      }
    } catch (error) {
      console.error("Error during AEPS transaction filter:", error);
      message.error('Failed to fetch data. Please try again.');
      setAepsData({ data: [] });
    } finally {
      setLoading(false);
    }
  };

  const getDmtTxnData = async (num) => {
    setLoading(true);
    try {
      const res = await getDataReports({ 
        ...initialValues, 
        page: num, 
        count, 
        category_id: param.id 
      });
      if (res && res.data) {
        setAepsData(res);
      } else {
        setAepsData({ data: [] });
        message.info('No data available');
      }
    } catch (error) {
      console.error("Error fetching DMT transaction data:", error);
      message.error('Failed to fetch transaction data. Please try again.');
      setAepsData({ data: [] });
    } finally {
      setLoading(false);
    }
  };

  const downloadExcel = async () => {
    try {
      setLoading(true);
      const res = await getDataReportsAllexcel({
        ...initialValues,
        category_id: param.id
      });

      if (res && res.data && res.data.length > 0) {
        const dataForExcel = res.data.map((item, i) => ({
          "Sr. No": i + 1,
          "Date / Time": item?.createdAt,
          "Name": item?.name,
          "Retailer code": item?.refer_id,
          "Retailer Mobileno": item?.retailer_mobile,
          "Transaction ID": item?.txn_id,
          "Ref ID": item?.refId,
          "Ca Number": item?.ca_num,
          "Operator name": item?.operator_name,
          "Operator ID": item?.biller_id,
          "Transction  Reference ID": item?.txnReferenceceId,
          "Updated ": item?.updatedAt,
          "Amount": item?.amount,
          "Opening Balance": item?.open_bal,
          "Clsing Balance":item?.close_bal,
          "Status": item?.status === 2 ? 'Success' :
          item?.status === 1 ? 'Pending' :
          item?.status === 3 ? 'Failed' :
          item?.status === 4 ? 'Refund' :
          'Unknown',
          'Distributor Name': item.distributor_name || "",
          'Distributor Commission': item.distributor_commission || "",
          'Super Distributor Name': item.master_dist_name || "",
          'Super Distributor Commission': item.master_dist_commission || "",
          'Distributor Contact': item.distributor_mobile || "",
          'Super Distributor Contact': item.master_dist_mobile || "",
          'Distributor Refer Id': item.distributor_refer_id || "",
          'Super Distributor Refer Id': item.master_dist_refer_id || "",
        }));

        const ws = XLSX.utils.json_to_sheet(dataForExcel);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Fastag Report");
        XLSX.writeFile(wb, `Elelctric_city_Report_${new Date().toLocaleDateString()}.xlsx`);
      } else {
        message.error('No data available to export!');
      }
    } catch (error) {
      console.error("Error downloading Excel:", error);
      message.error('Failed to download Excel. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handlePageSizeChange = (e) => {
    const newPageSize = parseInt(e.target.value);
    setCount(newPageSize);
    setPage(0);
    getDmtTxnData(0);
  };

  const onChangeVal = (e) => {
    setPage(e - 1);
    setTimeout(() => {
      getDmtTxnData(e - 1);
    }, 1000);
  };

  useEffect(() => {
    getDmtTxnData(0);
  }, []);

  const responseEnquiry = async (id) => {
    setLoading(true); // Start loader before API call
    try {
        const res = await paymentEnquirybbps(id);
        if (res?.data?.statusCode == "200") {
            message.success(res?.data?.message || "Operation successful");
            getDmtTxnData(page);
        } else if (res?.data?.statusCode == "300") {
            message.info(res?.data?.message || "Transaction requires attention");
            getDmtTxnData(page);
        } else {
            message.error(res?.message || res?.data?.message || "failed");
            getDmtTxnData(page);
        }
    } catch (error) {
        console.error("Error in payment enquiry:", error);
        message.error("An error occurred while processing your request");
    } finally {
        setLoading(false); // Stop loader after API call completes
    }
};

  return (
    <>
      {loading && <Loadar />}
      <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />
      <SameCompFilter 
        title={title} 
        initialValues={initialValues} 
        userData={userData} 
        submitForm={submitForm} 
        aepsData={aepsData}   
        setInitialValues={setInitialValues} 
        getDmtTxnData={getDmtTxnData} 
      />
      {aepsData.data.length > 0 ? (
        <FastagListReports 
          title={title} 
          onChangeVal={onChangeVal} 
          aepsData={aepsData} 
          getDmtTxnData={getDmtTxnData} 
          downloadExcel={downloadExcel}  
          count={count}
          handlePageSizeChange={handlePageSizeChange} 
          responseEnquiry ={responseEnquiry }
          loading2={loading2}
        />
      ) : (
        <div className="text-center mt-4">
          <h3>No data available</h3>
        </div>
      )}
    </>
  )
}

export default FastagMainComp

